import { useEffect, useState } from "react";

export function useClientSize(elm: HTMLElement | null) {
  const [height, setHeight] = useState<number | null>(null);
  const [width, setWidth] = useState<number | null>(null);

  useEffect(() => {
    if (!elm) {
      return;
    }
    setHeight(elm.clientHeight);
    setWidth(elm.clientWidth);
    const handler = () => {
      setHeight(elm.clientHeight);
      setWidth(elm.clientWidth);
    };
    window.addEventListener("resize", handler);

    return () => window.removeEventListener("resize", handler);
  }, [elm]);

  return {
    screenHeight: height,
    screenWidth: width,
  };
}
